import React from 'react'
import styled from 'styled-components/macro'

// External-link glyph indicating the pill opens the cited element in a new tab.
const ExternalLinkIcon = (): JSX.Element => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    style={{ flexShrink: 0, color: '#515d75' }}
  >
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
)

// Compact, pill-shaped citation link for the Activities index grid. Mirrors the
// CitationCapsule in CitationsPopover but at the ~24px height used by the control
// index BasicChip so it fits the tighter row height.
const PillAnchor = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-height: 24px;
  max-width: 100%;
  padding: 3px 10px;
  background: #f1f3f5;
  border-radius: 999px;
  color: #1f2532;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: #e2e6ea;
  }
`

const PillText = styled.span`
  /* Wrap long citations instead of truncating, matching the popover dialog. */
  word-break: break-word;
  overflow-wrap: break-word;
  min-width: 0;
`

export const CitationPill = ({
  text,
  url,
}: {
  text: string
  url: string
}): JSX.Element => (
  <PillAnchor href={url} target="_blank" rel="noopener noreferrer" title={text}>
    <PillText>{text}</PillText>
    <ExternalLinkIcon />
  </PillAnchor>
)
